import React, { useState, useEffect } from "react";
import { Row, Col, Button, Space, Tabs, Breadcrumb } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase, faIndustry } from "@fortawesome/free-solid-svg-icons";
import MappedCompany from "./MappedCompany";
import LookupData from "./LookupData";
import { FormattedMessage, useIntl } from "react-intl";
import { DoubleRightOutlined, HomeOutlined } from "@ant-design/icons";

function Settings() {
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part detailsposition">
            <Row align="middle" justify="space-between" gutter={[16, 16]}>
              <Col xs={24} md={12} lg={12}>
                <h4>{<FormattedMessage id="Common.Settings" />}</h4>
                <p className="mt-5px">
                  Add or edit mapped companies and manage lookup data.
                </p>
              </Col>
              <Col className="text-right detailsbtns" xs={24} md={12} lg={12}>
                <Space>
                  <Breadcrumb
                    separator={<DoubleRightOutlined />}
                    items={[
                      {
                        title: <FormattedMessage id="Common.Home" />,
                        href: `/landingPage`,
                      },
                      {
                        title: <FormattedMessage id="Common.Settings" />,
                      },
                    ]}
                  />
                </Space>
              </Col>
            </Row>
          </div>
          <Tabs onChange={onChange}>
            <Tabs.Item
              tab={
                <span>{<FormattedMessage id="Common.MappedCompany" />}</span>
              }
              key="1"
            >
              <MappedCompany />
            </Tabs.Item>
            <Tabs.Item
              tab={<span>{<FormattedMessage id="Common.LookupData" />}</span>}
              key="2"
            >
              <LookupData />
            </Tabs.Item>
          </Tabs>
        </div>
      </div>
    </>
  );
}
export default Settings;
